import { usePost } from '../usePost';

const API_URL = import.meta.env.VITE_API_URL;

export function useRemoverPessoaTelefone() {
  return usePost({
    url: `${API_URL}/pessoas/remover-telefone`,
    config: {
      timeout: 120000,
      getAccessToken: true,
    },
  });
}
